import request from "@/utils/request"; // 引入request,基于axios
import queryString from "querystring"; // post方法传参转型String

export function getResult(data) {
  return request({
    url: `/enjoyment-server/app/user/answer/` + data.id + `/report`,
    method: "get",
    data: data,
  });
}
